import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Alert, Button, Card, CardBody, Input, Table } from "reactstrap";

import { confirm } from "components/Confirmation";

import { formatNumber } from "services/Utils";
import { onlyNumbers } from "services/Utils";
import IconButton from "components/IconButton";
import consorcioService from "services/ConsorcioService";
import comboService from "services/ComboService";

export default function Empresas({ edit, idConsorcio, onChange }) {
  const [items, setItems] = useState([])
  const [alteracao, setAlteracao] = useState(false)
  const [empresas, setEmpresas] = useState([])
  const [participante, setParticipante] = useState()

  useEffect(() => {
    comboService.empresa().then(res => {
      if (res.success) {
        setEmpresas(res.data)
      }
    })
  }, [])

  useEffect(() => {
    if (!edit) {
      setParticipante(null)
      setAlteracao(false)
    }
  }, [edit])

  const carregar = async () => {
    const res = await consorcioService.getEmpresas(idConsorcio)
    if (res.success) {
      setItems(res.data)
    }
  }

  useEffect(() => {
    if (!idConsorcio)
      return
    carregar()
  }, [idConsorcio])

  const totalParticipacao = useMemo(() => {
    return items.filter(el => alteracao ? el.idEmpresa !== participante.idEmpresa : true).map(el => el.participacao).reduce((total, atual) => total + atual, 0) + (participante?.participacao || 0)
  }, [items, participante])

  const mensagemParticipacao = useMemo(() => {
    const retorno = { mensagem: '', severity: 'success' }
    if (totalParticipacao == 100) {
      retorno.mensagem = "A soma da participação das empresas é 100%"
    } else {
      if (totalParticipacao > 100) {
        retorno.mensagem = `A soma da participação das empresas ultrapassou os 100% em ${formatNumber(totalParticipacao - 100)}%`
      } else {
        retorno.mensagem = `Resta(m) ${formatNumber(100 - totalParticipacao)}% para distribuir entre as empresas`
      }
      retorno.severity = "error"
    }
    return retorno
  }, [totalParticipacao])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!participante) return

    const reg = empresas.find(el => el.id == participante.idEmpresa)
    if (!reg) return

    const lider = items.length == 0

    try {

      let res = null
      if (alteracao) {
        res = await consorcioService.updateEmpresa(idConsorcio, participante.idEmpresa, {
          participacao: participante.participacao,
        })
      } else {
        res = await consorcioService.createEmpresa(idConsorcio, {
          idEmpresa: reg.id,
          participacao: participante.participacao,
          lider
        })
      }

      if (res.success) {
        carregar()
        onChange && onChange()
        toast("O registro foi salvo com sucesso")
      } else {
        toast("Erro ao salvar o registro")
      }
    } catch (ex) {
      toast("Erro ao salvar o registro")
    }

    setParticipante(null)
    setAlteracao(null)
  }

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await consorcioService.deleteEmpresa(idConsorcio, item.idEmpresa)
          if (res.success) {
            carregar()
            toast("O registro foi excluído com sucesso")
          } else {
            toast("Erro ao excluir o registro")
          }
        } catch (ex) {
          toast("Erro ao excluir o registro")
        }
      }
    })
  }

  const handleEdit = (id) => {
    const participante = items.find(el => el.id === id)
    if (!participante) return
    setParticipante({ id, idEmpresa: participante.idEmpresa, participacao: participante.participacao })
    setAlteracao(true)
  }

  const handleCancelEdit = () => {
    setParticipante(null)
    setAlteracao(false)
  }

  const handleEmpresa = (e) => {
    const _participante = participante || {}
    _participante.idEmpresa = e.target.value
    _participante.participacao = _participante.participacao || 0
    setParticipante({ ..._participante })
  }

  const handleParticipacao = (e) => {
    const value = parseFloat(onlyNumbers(e.target.value) || '0') / 100
    const _participante = participante || {}
    _participante.idEmpresa = _participante.idEmpresa || 0
    _participante.participacao = value
    setParticipante({ ..._participante })
  }

  const handleChangeLider = async (idEmpresa, checked) => {
    if (!checked) return // não permite desmarcar, apenas escolher outro

    try {
      await consorcioService.updateEmpresaLider(idConsorcio, idEmpresa)
      onChange && onChange()
      carregar()
      toast("O registro foi salvo com sucesso")
    } catch (ex) {
      toast("Erro ao salvar o registro")
    }
  }

  return (
    <>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Razão Social</th>
            <th scope="col">CNPJ</th>
            <th scope="col">Participação</th>
            <th scope="col">Líder</th>
            {edit && (
              <th scope="col" style={{ width: 120 }}></th>
            )}
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={4} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.filter(el => alteracao ? el.idEmpresa !== participante.idEmpresa : true).map(el => (
            <tr key={el.idEmpresa}>
              <td>{el.razaoSocial}</td>
              <td>{el.cnpj}</td>
              <td>{formatNumber(el.participacao) + '%'}</td>
              <td>
                <label className="custom-toggle" style={{ marginBottom: 0 }}>
                  <input type="checkbox" name="lider" value={el.id} checked={el.lider} onChange={e => handleChangeLider(el.idEmpresa, e.target.checked)} disabled={!edit} />
                  <span className="custom-toggle-slider rounded-circle" />
                </label>
              </td>
              {edit && (
                <td className="d-flex flex-row gap-5px">
                  <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => handleEdit(el.id)} />
                  <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>

      {items.length > 0 && (
        <Alert
          color={mensagemParticipacao.severity === 'error' ? 'danger' : "primary"}
          className="text-center"
          style={{ marginTop: 20 }}
        >
          {mensagemParticipacao.mensagem}
        </Alert>
      )}

      {edit && (
        <Card>
          <CardBody>
            <h2>Adicionar Participante</h2>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-4 field">
                  <label htmlFor="cnpj">Empresa</label>
                  <select className="form-control" value={participante?.idEmpresa || ''} onChange={handleEmpresa} disabled={alteracao}>
                    <option value="">Selecione</option>
                    {empresas
                      .filter(
                        el => {
                          if (alteracao) 
                            return el.id == participante.idEmpresa // se for alteração trazer apenas a empresa que está sendo alterada
                          return !items.some(p => p.idEmpresa == el.id) // caso contrário trazer todas que não estão na lista
                        }
                      ).map(el => ({ value: el.id, label: el.razaoSocial })).map(el => (
                        <option key={el.value} value={el.value}>{el.label}</option>
                      ))}
                  </select>
                </div>
                <div className="col-2 field">
                  <label htmlFor="participacao">Participação</label>
                  <Input
                    id="participacao"
                    value={formatNumber(participante?.participacao || 0)}
                    onChange={handleParticipacao}
                  />
                </div>

                <div className="col-4 field" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start' }}>
                  {alteracao ? (
                    <>
                      <Button color="primary" type="submit" disabled={!participante}>Alterar</Button>
                      <Button color="danger" outline className="ml-2" onClick={handleCancelEdit}>Cancelar edição</Button>
                    </>
                  ) : (
                    <Button color="primary" type="submit" disabled={!participante}>Adicionar</Button>
                  )}
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      )}
    </>
  )
}